export function OnGoingTickets({ active = false }: any) {
  const color = active ? "#006AB3" : "#84818A";
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.31348 7.49354C2.31348 4.40805 4.08121 3.08569 6.7328 3.08569H15.5714C18.223 3.08569 19.9908 4.40805 19.9908 7.49354V13.6645C19.9908 16.75 18.223 18.0724 15.5714 18.0724H6.7328"
        stroke={color}
        stroke-width="1.58683"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.5716 7.93408L12.8051 10.138C11.8947 10.8609 10.4009 10.8609 9.49056 10.138L6.73291 7.93408"
        stroke={color}
        stroke-width="1.58683"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.31348 14.5459H7.61667"
        stroke={color}
        stroke-width="1.58683"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.31348 11.0198H4.96507"
        stroke={color}
        stroke-width="1.58683"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
